import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import { Facts } from "../components/Facts";
import { FaqList } from "../components/FaqList";
import { Hero } from "../components/Hero";
import { LocationGrid } from "../components/LocationGrid";
import { PageFrame } from "../components/PageFrame";
import { Reveal } from "../components/Reveal";
import { SectionHeading } from "../components/SectionHeading";
import { TrainerGrid } from "../components/TrainerGrid";
import { aboutParagraphs, faqItems } from "../content/siteContent";

export function HomePage() {
  return (
    <PageFrame className="home-page">
      <Hero />

      <Reveal className="home-about page-section technical-frame">
        <div>
          <SectionHeading title="Ο Σύλλογος" />
          <p>{aboutParagraphs[0]}</p>
          <p>{aboutParagraphs[1]}</p>
          <Link className="text-link" to="/o-syllogos" data-target>
            Διαβάστε περισσότερα
            <ArrowRight aria-hidden="true" />
          </Link>
        </div>
        <Facts />
      </Reveal>

      <Reveal className="page-section technical-frame">
        <SectionHeading title="Τοποθεσίες" />
        <LocationGrid compact />
        <Link className="text-link section-link" to="/topothesies" data-target>
          Δείτε τις τοποθεσίες
          <ArrowRight aria-hidden="true" />
        </Link>
      </Reveal>

      <Reveal className="page-section technical-frame">
        <SectionHeading title="Εκπαιδευτές" />
        <TrainerGrid />
        <Link className="text-link section-link" to="/ekpaideftes" data-target>
          Γνωρίστε τους εκπαιδευτές
          <ArrowRight aria-hidden="true" />
        </Link>
      </Reveal>

      <Reveal className="page-section technical-frame">
        <SectionHeading title="Ερωτήσεις" />
        <FaqList />
        <p className="visually-hidden">{faqItems.length} διαθέσιμες ερωτήσεις</p>
        <Link className="text-link section-link" to="/erotiseis" data-target>
          Όλες οι ερωτήσεις
          <ArrowRight aria-hidden="true" />
        </Link>
      </Reveal>
    </PageFrame>
  );
}
